"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CmsButton = exports.CmsButtonComp = void 0;
var tslib_1 = require("tslib");
var React = require("react");
var react_i18next_1 = require("react-i18next");
var Catch_1 = require("../../Catch");
var ParamExtractor_1 = require("@wix/dealer-common/dist/src/services/ParamExtractor");
var CmsButtonComp = /** @class */ (function (_super) {
    tslib_1.__extends(CmsButtonComp, _super);
    function CmsButtonComp() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CmsButtonComp.prototype.getTranslatedValue = function () {
        var _a = this.props, element = _a.element, context = _a.context, t = _a.t;
        var textKey = element.textKey;
        var paramServer = (ParamExtractor_1.extractParam(element, context, 'params') || []).map(function (e) { return e.string; });
        var params = tslib_1.__spreadArrays(paramServer);
        return t(textKey, params);
    };
    CmsButtonComp.prototype.render = function () {
        var _this = this;
        var sanitizedObjectFunc = function () { return ({ __html: _this.getTranslatedValue() }); };
        return Catch_1.Catch({
            onError: this.props.onError,
            render: function () { return React.createElement("span", { dangerouslySetInnerHTML: sanitizedObjectFunc() }); },
        });
    };
    return CmsButtonComp;
}(React.Component));
exports.CmsButtonComp = CmsButtonComp;
exports.CmsButton = react_i18next_1.translate('', { wait: true })(CmsButtonComp);
//# sourceMappingURL=CmsButton.js.map